export function initPrenotaOraButton() {
    const btn = document.querySelector('.prenota-ora-button');
    if (!btn) return;

    // Threshold = top_iniziale - top_sticky = 150 - 50
    const THRESHOLD = 100;

    window.addEventListener('scroll', () => {
        btn.classList.toggle('scrolled', window.scrollY > THRESHOLD);
    }, { passive: true });
}
